import { MDBTable } from "mdbreact";
import { currency } from "../../../services/utilities";
import React from "react";

const Row = ({ item, mark = false }) => {
  const { menu, amount, srp, discount = 0, qty = 1 } = item;
  const { description, abbreviation } = menu;

  return (
    <>
      <tr>
        <td
          colSpan={4}
          style={{ fontSize: "17.5px" }}
          className="text-left py-0  text-uppercase px-0"
        >
          {description || abbreviation}
          {mark && " **"}
        </td>
      </tr>
      <tr>
        <td style={{ fontSize: "17.5px" }} colSpan={4} className=" py-0 px-0 ">
          <div className="d-flex justify-content-between">
            <div>x{qty}</div>
            <div className="text-left"> {currency.format(srp)}</div>
            <div className="text-right">
              {currency.format(amount + discount)}
            </div>
          </div>
        </td>
      </tr>
    </>
  );
};

const Section = ({ title }) => (
  <tr>
    <th colSpan={4} className="text-left py-0 px-0 pt-1" style={{ fontSize: "17.5px" }}>
      {title}
    </th>
  </tr>
);

// dashed line between the promo and the discountable items
const Divider = ({ colSpan }) => (
  <tr>
    <td colSpan={colSpan} className="p-0">
      <hr
        style={{ border: "none", borderTop: "1px dashed #000", height: 0 }}
        className="my-1"
      />
    </td>
  </tr>
);

// markFixed: PWD / Senior / Indigenous sale, the items without discount
// are listed apart (promo) from the discountable ones
const Body = ({ cart, markFixed = false }) => {
  const items = Array.isArray(cart) ? cart : [];
  const fixed = markFixed ? items.filter(({ discount = 0 }) => !(discount > 0)) : [];
  const discountable = markFixed ? items.filter(({ discount = 0 }) => discount > 0) : items;

  return (
    <MDBTable responsive borderless className="mb-0 thermal-font">
      <thead>
        <tr>
          <th className="py-1 px-0 text-left" style={{ fontSize: "17.5px" }}>
            Menus
          </th>
          <th className="py-1 text-center" style={{ fontSize: "17.5px" }}>
            Qty
          </th>
          <th className="py-1 text-center" style={{ fontSize: "17.5px" }}>
            SRP
          </th>
          <th className="py-1 text-right px-0 " style={{ fontSize: "17.5px" }}>
            Sub-Total
          </th>
        </tr>
      </thead>
      <tbody>
        {markFixed && <Section title="PROMO ITEMS" />}
        {fixed.map((item, index) => (
          <Row key={`fixed-${index}`} item={item} mark />
        ))}
        {markFixed && <Divider colSpan={4} />}
        {markFixed && <Section title="DISCOUNTABLE ITEMS" />}
        {discountable.map((item, index) => (
          <Row key={`menu-${index}`} item={item} />
        ))}
      </tbody>
    </MDBTable>
  );
};

export default Body;
